module.exports = __webpack_public_path__ + "static/media/Otros Sistemas(A).f45a42ab.svg";